import type { SVGAttributes } from 'react';

export function ShareXIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="#fff" rx="4" />
			<path
				fill="currentColor"
				d="M15.805 6h2.037l-4.473 5.092L18.594 18h-4.1l-3.21-4.198L7.608 18H5.571l4.738-5.446L5.306 6h4.202l2.9 3.835zm-.713 10.804h1.129L8.915 7.151H7.7z"
			/>
		</svg>
	);
}
